export default __webpack_public_path__ + "static/media/ENTP-4.2db62877.png";